import { WorkspaceWindowTypeEnumType } from '@mark43/cad-api';
import { useMatch } from 'react-router-dom';
import {
    EVENTS_WINDOW_PATH,
    EVENT_SEARCH_WINDOW_PATH,
    QUEUES_WINDOW_PATH,
    UNIT_STATUS_SEARCH_WINDOW_PATH,
    MAP_WINDOW_PATH,
    BOLO_SEARCH_WINDOW_PATH,
} from '../../router/constants';

export function useWorkspaceWindowType(): WorkspaceWindowTypeEnumType {
    const isQueues = useMatch(QUEUES_WINDOW_PATH);
    const isEvents = useMatch(EVENTS_WINDOW_PATH);
    const isEventSearch = useMatch(EVENT_SEARCH_WINDOW_PATH);
    const isUnitStatusSearch = useMatch(UNIT_STATUS_SEARCH_WINDOW_PATH);
    const isBoloSearch = useMatch(BOLO_SEARCH_WINDOW_PATH);
    const isMap = useMatch(MAP_WINDOW_PATH);

    if (isQueues) {
        return 'QUEUE_V2';
    } else if (isEvents) {
        return 'EVENT_V2';
    } else if (isEventSearch) {
        return 'EVENT_SEARCH_V2';
    } else if (isUnitStatusSearch) {
        return 'UNIT_STATUS_SEARCH_V2';
    } else if (isBoloSearch) {
        return 'BOLO_SEARCH';
    } else if (isMap) {
        return 'MAP_V2';
    } else {
        return 'QUEUE_V2';
    }
}
